import { ICreateChecklistEntregaUseCase } from "../../../presentation/useCases/create/create_checklist_entrega_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateChecklistEntregaUseCase
 */

export class CreateChecklistEntregaUseCase implements ICreateChecklistEntregaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    codigo?: string,
    descricao?: string,
    revisao?: string,
    campo1?: string,
    campo2?: string,
    campo3?: string,
    campo4?: string,
  ): Promise<number> {
    return this.repository.createChecklistEntrega(
      codigo,
      descricao,
      revisao,
      campo1,
      campo2,
      campo3,
      campo4,
    );
  }
}
